<template>
  <div id="expiredURL" class="notranslate">
    <h1 class="colorRed">Expired URL</h1>
    <h2 class="colorGrey">이 링크는 만료된 url입니다.</h2>
  </div>
</template>

<script>
export default {
  name: 'Expired'
}
</script>

<style lang="scss" scoped>
#expiredURL {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  padding: 0.3em 15px 8em;
  text-align: center;
  line-height: 1.3;
  transform: translate(0, -50%);
}
h1 {
  font-size: 3.2em;
  font-weight: bold;
  &:before {
    content: "\26A0";
    display: block;
    font-size: 3em;
    color: $color-lgrey;
    line-height: 1;
    opacity: 0.5;
  }
}
h2 {
  margin-top: 1em;
  font-size: 1.1em;
}
</style>
